function objectReducer(state, action){
    return {...state, ...action}
}

export { objectReducer }